import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface FileUploadAreaProps {
  currentPath: string; // Caminho da pasta atual
  onConfirmUpload: (files: File[]) => void; // Agora recebe uma lista de arquivos
}

const FileUploadArea: React.FC<FileUploadAreaProps> = ({ currentPath, onConfirmUpload }) => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      setUploadedFiles(files);
      onConfirmUpload(files);

      toast.success(`${files.length} arquivo(s) anexado(s) com sucesso!`);
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  };

  return (
    <div
      style={{
        border: `2px ${isDragOver ? "solid" : "dashed"} #1976d2`,
        padding: "20px",
        textAlign: "center",
        transition: "border 0.2s ease-in-out",
        backgroundColor: isDragOver ? "#e3f2fd" : "transparent",
      }}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      {uploadedFiles.length > 0 ? (
        <div style={{ color: "#1976d2", fontWeight: "bold" }}>
          {uploadedFiles.map((file, index) => (
            <p key={index}>✅ {file.name}</p>
          ))}
        </div>
      ) : (
        <p>Ou arraste e solte seus arquivos aqui!</p>
      )}
    </div>
  );
};

export default FileUploadArea;
